import kfh from "../components/pictures/logos/kfh.png";
import phinests from "../components/pictures/logos/phinests_logo.png";
import ican from "../components/pictures/logos/ican.png";
import KFASLogo from "../components/pictures/logos/KFAS_Logo.png";

export const experiencesData = [
  // Add data for other experiences here
  {
    roles: ["senior_software_engineer", "software_engineer"].map((role) => ({
      date: `experiences.${role}.date`,
      jobTitle: `experiences.${role}.jobTitle`,
      description: `experiences.${role}.description`,
      descriptionList: [0, 1, 2].map(
        (index) => `experiences.${role}.descriptionList.${index}`,
      ),
    })),
    icon: (
      <img
        src={phinests}
        alt="Phinests Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    companyName: "Phinests",
    link: "https://phinests.com",
    moreLink: "/projects/phinests-platform",
    skills: [
      "Ruby on Rails",
      "Next.js",
      "StimulusJS",
      "Turbo",
      "PostgreSQL",
      "MyFatoorah",
      "Zendesk",
    ],
  },
  {
    date: "2020 - 2021",
    icon: (
      <img
        src={kfh}
        alt="KFH Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    jobTitle: "experiences.soc_analyst.jobTitle",
    companyName: "experiences.soc_analyst.companyName",
    link: "https://www.kfh.com/",
    description: "experiences.soc_analyst.description",
  },
  {
    date: "2018 - 2019",
    icon: (
      <img
        src={ican}
        alt="I Can Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    jobTitle: "experiences.administrative.jobTitle",
    companyName: "experiences.administrative.companyName",
    description: "experiences.administrative.description",
    descriptionList: [
      "experiences.administrative.descriptionList.0",
      "experiences.administrative.descriptionList.1",
      "experiences.administrative.descriptionList.2",
      "experiences.administrative.descriptionList.3",
      "experiences.administrative.descriptionList.4",
    ],
  },
];

export const volunteerData = [
  {
    icon: <img src={KFASLogo} alt="KFAS × CODED" />,
    jobTitle: "career.volunteerRole",
    companyName: "KFAS × CODED",
    description: "volunteer.description",
    date: "2020",
  },
];
